/* eslint-disable arrow-parens */
// initial state
const state = {
  loading: false,
  language: 'en',
};

// getters
const getters = {
  loading: (currentState) => currentState.loading,
  language: (currentState) => currentState.language,
};

// actions
const actions = {
  showLoader({ commit }) {
    commit('setLoading', { loading: true });
  },
  hideLoader({ commit }) {
    commit('setLoading', { loading: false });
  },
  setLanguage({ commit }, selectedLanguage) {
    commit('setLanguage', { language: selectedLanguage });
  },
};

// mutations
const mutations = {
  setLoading(currentState, { loading }) {
    currentState.loading = loading;
  },
  setLanguage(currentState, { language }) {
    currentState.language = language;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/general.js